import DOMPurify from "dompurify";


/** ——— Custom matcher (supports optgroups + chained terms) ——— */
// This matcher function adds support for:
// - searching nested options (optgroup)
// - chaining multiple partial terms (using AND operator) searching 'this thing' will return a record labeled 'this really great thing'
// NOTE: matcher is not used when using ajax

export function customMatcher(params, data) {
  data.parentText = data.parentText || "";
  if ($.trim(params.term) === "") return data;

  if (data.children && data.children.length > 0) {
    const match = $.extend(true, {}, data);
    for (let c = data.children.length - 1; c >= 0; c--) {
      const child = data.children[c];
      child.parentText += data.parentText + " " + data.text;
      const matches = customMatcher(params, child);
      if (matches == null) match.children.splice(c, 1);
    }
    if (match.children.length > 0) return match;
    return customMatcher(params, match);
  }

  const original = (data.parentText + " " + data.text).toUpperCase().trim();
  const terms = params.term.toUpperCase().split(" ");

  if (terms.every((term) => (original.includes(term)))) {
    return data;
  }
  return null;
}



// Convert sanitized HTML string to a jQuery object, or null if empty after sanitization
export function domFromHtml(html, allowedTags) {
  const clean = DOMPurify.sanitize(html || "", { ALLOWED_TAGS: allowedTags ?? [] });
  return clean ? $(clean) : null;
}
